import { isNumber } from '@veracity/vui'
import { useParams } from 'react-router-dom'

export const useRouteIdParam = (paramName: string) => {
  const params = useParams()

  const paramValue = params[paramName]

  return !!paramValue && isNumber(+paramValue) ? +paramValue : undefined
}
